module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Clothes/Shoes-aa6c04b8a11b885baf11c2e2304eb30a6feea1ad2186c9446968678ae0be7de2.svg";